import { FormControl, FormControlLabel, FormHelperText } from '@mui/material';
import { Switch as MuiSwitch, SwitchProps } from 'formik-mui';
import { styled } from 'styled-components';

const StyledFormControlLabel = styled(FormControlLabel)`
    .MuiTypography-root {
        font-weight: 700;
        font-size: ${({ theme }) => theme.typography.pxToRem(16)};
    }
`;

const StyledSwitch = styled(MuiSwitch)`
    .MuiSwitch-switchBase {
        + .MuiSwitch-track {
            background-color: ${({ theme }) =>
                theme.vars.palette.primary.light};
        }

        &.Mui-checked {
            color: ${({ theme }) => theme.vars.palette.primary.main};
        }
    }
`;

interface IProps extends SwitchProps {
    helperText?: string;
    label?: string;
    formControlProps?: React.ComponentProps<typeof FormControl>;
}

export const Switch = ({
    disabled,
    helperText,
    label,
    field,
    form,
    formControlProps,
    ...other
}: IProps) => {
    const error = form.errors[field.name];
    const { setFieldValue } = form;

    return (
        <FormControl
            fullWidth
            margin="dense"
            variant="standard"
            {...formControlProps}
        >
            <StyledFormControlLabel
                control={
                    <StyledSwitch
                        disabled={disabled}
                        field={field}
                        form={form}
                        tabIndex={-1}
                        type="checkbox"
                        {...other}
                    />
                }
                label={label}
                tabIndex={0}
                onKeyDown={(e) => {
                    if (e.key !== ' ' || disabled) return;

                    setFieldValue(field.name, !field.value);
                }}
            />

            {!!helperText && (
                <FormHelperText sx={{ ml: 6 }}>{helperText}</FormHelperText>
            )}

            {error && <FormHelperText error>{String(error)}</FormHelperText>}
        </FormControl>
    );
};
